import { queryOptions } from '@tanstack/vue-query'
import { type MaybeRefOrGetter, toValue } from 'vue'
import { fetchYield } from '@/features/assets/api/fetchYield'
import { fetchAsset } from '@/features/assets/api/fetchAsset'
import { fetchYieldActivityLog } from '@/features/assets/api/fetchYieldActivityLog'

export const YieldQueries = {
  all: () => queryOptions({ queryKey: ['assets:yields'] }),

  fetch: (assetCode: MaybeRefOrGetter<string>) => queryOptions({
    queryKey: [...YieldQueries.all().queryKey, assetCode],
    queryFn: () => fetchYield(toValue(assetCode)),
    meta: {
      logger: 'features/assets/queries/YieldQueries.fetch'
    }
  }),

  activityLog: (assetCode: MaybeRefOrGetter<string>) => queryOptions({
    queryKey: ['assets:yields:log', assetCode],
    queryFn: () => fetchYieldActivityLog(toValue(assetCode))
  })
} as const

export const AssetQueries = {
  all: () => queryOptions({ queryKey: ['assets'] as const}),
  fetch: (assetCode: MaybeRefOrGetter<string|undefined>) => queryOptions({
    enabled: () => toValue(assetCode) !== undefined,
    queryKey: [...AssetQueries.all().queryKey, assetCode],
    queryFn: () => fetchAsset(toValue(assetCode)!),
    meta: {
      logger: 'features/assets/queries/AssetQueries.fetch'
    }
  }),
} as const
